"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const CrossIcon = () => ((0, jsx_runtime_1.jsx)("svg", { width: "15", height: "16", xmlns: "http://www.w3.org/2000/svg", children: (0, jsx_runtime_1.jsx)("path", { d: "M15 1.665L13.49.154 7.5 6.144 1.51.153 0 1.664l5.99 5.99L0 13.644l1.51 1.51 5.99-5.99 5.99 5.99 1.51-1.51-5.99-5.99z", fill: "#666", fillRule: "nonzero" }) }));
exports.CrossIcon = CrossIcon;
